import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { defaultVendorService } from 'contacts/services';
import { IDefaultVendorRequestPayload } from 'contacts/types';
import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';

export const useGetDefaultVendors = (
  requestPayload: IDefaultVendorRequestPayload,
  options: { enabled?: boolean } = {}
) => {
  const { t } = useTranslation();

  const { errors } = useHandleErrors({
    error: { title: t('errorTitleDefaultVendorListFetch') },
    position: NotificationPosition.DRAWER,
  });

  const { data, isLoading, isError, refetch } = useQuery(
    ['defaultVendorList', requestPayload],
    ({ signal }) => defaultVendorService.getDefaultVendors(requestPayload, signal),
    {
      enabled: options.enabled ?? true,
      onError: (err) => errors.onError(err, undefined),
    }
  );

  return {
    records: data?.records,
    isLoading,
    isError,
    refetch,
  };
};
